'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.daily_group_report', {
        template: '<daily-group-report></daily-group-report>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/group_report/daily/daily_group_report.routes.js